import { render } from "./number_controls.vue?vue&type=template&id=50a49654"
import script from "./number_controls.vue?vue&type=script&lang=js"
export * from "./number_controls.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__